import { useState, useRef } from 'react';
import { useTranslation } from '@utils/i18n/i18n';
import { Button } from '@nazka/nazka.mapframe.components';
import { useOnClickOutside } from '@services/hooks.service';

import './language-switch.css';

function LanguageSwitch({ color }) {
  const {
    lang, languages, setLang, 
  } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef();
  
  useOnClickOutside(ref, () => setIsOpen(false));

  return (
    <div className="language-switch" ref={ref}>
      <Button 
        className={`language-switch__button${isOpen ? ' language-switch__button--open' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
        css={{ 
          color, 
          borderColor: color,
          backgroundColor: isOpen ? `${color} !important` : '#fff',
          ':hover': {
            backgroundColor: color,
            borderColor: color,
            color: '#fff',
          },
        }}
      >
        {String(lang).toUpperCase()}
      </Button>
      {isOpen && (
        <div className="language-switch__menu">
          {languages.filter(l => l !== lang).map(l => (
            <Button 
              key={l}
              className="language-switch__button"
              css={{ 
                color, 
                borderColor: color,
                ':hover': {
                  backgroundColor: color,
                  borderColor: color,
                  color: '#fff',
                },
              }}
              onClick={() => {
                setLang(l);
                setIsOpen(false);
              }}
            >
              {String(l).toUpperCase()}
            </Button>
          ))}
        </div>
      )}
    </div>
  )
}

export default LanguageSwitch;